import { unities } from "@/common/constants/unities.constants";
import { ClientConsumptionData } from "@/common/types/client/consumption.type";
import { formatCurrency, formatDecimal, formatUnit } from "@/common/utils/formatters";

type ConsumptionEventableProps = {
  data: ClientConsumptionData;
};

const CompanyConsumptionDetails = ({ data: consumption }: ConsumptionEventableProps) => {

  return (
    <div className="flex flex-col gap-3">
      {consumption?.establishment_branch?.general_information?.fantasy_name && (
        <div className='flex gap-2 items-center'>
          <p className="italic">Estabelecimento: </p>
          <p className='font-bold'>{consumption?.establishment_branch?.general_information?.fantasy_name || '--'}</p>
        </div>
      )}
      <div className="flex flex-col justify-start">
        {consumption?.line_items.map((line_item) => (
          <p key={line_item.id}>
            {line_item.product.display_name} - {formatUnit(formatDecimal(line_item.quantity, 3), line_item.product.unit_for_quantity)} - {formatCurrency(Number(line_item.amount) / Number(line_item.quantity))} / {unities[line_item.product.unit_for_quantity]}
          </p>
        ))}
      </div>
    </div>
  );
};

export default CompanyConsumptionDetails;
